import React from 'react';
import { ShieldCheckIcon, StarIcon, ZapIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { CHECKOUT_URL, PRICE_FULL, PRICE_TODAY, PRODUCT_ALT, PRODUCT_IMG } from './constants';
export function FinalCTA() {
  return <section className="border-t-8 border-brand-orange bg-brand-graphite px-4 py-5 text-white" data-id="element-43" data-mp="c83ori435i4h">
      <div className="mx-auto max-w-3xl text-center" data-id="element-44" data-mp="83m8vu0ujoyz">
        <p className="mb-1 font-display text-[11px] font-semibold uppercase tracking-widest text-brand-gold sm:text-sm" data-id="element-45" data-mp="m4f0o6zrk5ye">
          Un’ultima occasione
        </p>
        <div className="mx-auto mb-2 max-w-2xl space-y-1 text-[13px] font-medium leading-snug text-white/85 sm:text-base" data-id="element-46" data-mp="h3raton9tv5r">
          <p data-id="element-47" data-mp="qvx5j64wqqon">
            Ogni settimana vengono pubblicati nuovi video. Nuovi dispositivi. Nuovi tutorial. Nuove
            automazioni. Nuove tecnologie. Ma continuare ad accumulare informazioni non significa
            avere un metodo.
          </p>
          <p data-id="element-48" data-mp="zy6dppcpe7yv">
            Puoi continuare a cercare ogni singola risposta separatamente... Oppure puoi partire da
            un sistema organizzato che ti mostra cosa imparare, in quale ordine e come applicarlo.
          </p>
          <p className="font-semibold text-white" data-id="element-49" data-mp="2h5kldry9xpk2">
            Comprendi le fondamenta. Progetta il sistema. Configura i dispositivi. Crea le
            automazioni. Integra gli ecosistemi. Realizza progetti completi.
          </p>
        </div>

        <a href={CHECKOUT_URL} className="mb-2 block" aria-label="Acquista SMART HOME PRO™" data-id="element-50" data-mp="2v2hfc29ovn56">
          <img src={PRODUCT_IMG} alt={PRODUCT_ALT} className="mx-auto w-full max-w-[210px] object-contain drop-shadow-2xl transition-transform duration-200 ease-out hover:scale-[1.02]" data-id="element-51" data-mp="301k6qjwqxuuo" />
        </a>

        <div className="mb-2 rounded-2xl border border-white/15 bg-white/10 p-3" data-id="element-52" data-mp="39uhrkwp7nvwg">
          <p className="font-display text-xs font-bold uppercase leading-snug tracking-wide text-white sm:text-base" data-id="element-53" data-mp="3etcmuy4d7cxg">
            SMART HOME PRO™
          </p>
          <p className="mb-1 text-[11px] font-semibold text-white/85 sm:text-sm" data-id="element-54" data-mp="1jnk0m3kpvmr2">
            Sistema Completo 6-in-1 per Imparare, Installare e Gestire la Domotica + 5 Bonus Premium
          </p>
          <p className="text-sm sm:text-lg" data-id="element-55" data-mp="1sgx0xql41qn6">
            <span className="text-white/60 line-through" data-id="element-56" data-mp="1shydy0losn7j">Prezzo Regolare: {PRICE_FULL}</span>{' '}
            |{' '}
            <span className="font-display font-extrabold text-brand-gold" data-id="element-57" data-mp="1no3u8x63088g">
              SOLO OGGI: {PRICE_TODAY}
            </span>
          </p>
        </div>

        <CTAButton href={CHECKOUT_URL} className="mx-auto mb-2 max-w-md" data-id="element-58" data-mp="1xeyk0bijdpyn">
          🚀 SÌ! VOGLIO IL MIO SMART HOME PRO™
        </CTAButton>

        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[11px] font-semibold text-white/90 sm:text-sm" data-id="element-59" data-mp="2bd6kuuip1bf3">
          <span className="flex items-center gap-1" data-id="element-60" data-mp="h0qb3jqovf5h">
            <ZapIcon className="h-4 w-4 text-brand-gold" aria-hidden="true" data-id="element-61" data-mp="h3bcy8qzlv38" />
            Accesso Immediato • Consegna Digitale via Email
          </span>
          <span className="flex items-center gap-1" data-id="element-62" data-mp="2x11vmm3026n">
            <StarIcon className="h-4 w-4 fill-brand-gold text-brand-gold" aria-hidden="true" data-id="element-63" data-mp="6xjuvjzpneaf" />
            ⭐⭐⭐⭐⭐ 4,9/5 — Recensioni Verificate
          </span>
          <span className="flex items-center gap-1" data-id="element-64" data-mp="3pb17as3dw3b8">
            <ShieldCheckIcon className="h-4 w-4 text-brand-gold" aria-hidden="true" data-id="element-65" data-mp="3uaduxf22xeev" />
            🛡️ Garanzia Soddisfatti o Rimborsati di 14 Giorni
          </span>
        </div>
      </div>
    </section>;
}